import { useState } from "react";
import { handleApiCall, handleApiCallFormData } from "../services/httpConfig";
import { eventData } from "../data/eventData";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const useEventState = () => {
  const [events, setEvents] = useState([]);
  const [latestEvent, setLatestEvent] = useState({});
  const [attendees, setAttendees] = useState([]);
  const [dataCSV, setDataCSV] = useState();
  const [CSVFileName, setCSVFileName] = useState("");

  const navigate = useNavigate();

  //  api to submit form
  const addAttendee = async (payload) => {
    try {
      const response = await handleApiCall("api/add_attendee", "POST", payload);
      toast.success("Successfully been added as an attendee");
      window.location.href = latestEvent.whatsapp_url;
      return response;
    } catch (err) {
      console.log(err);
    }
  };

  // get attendees
  const getAttendees = async (event) => {
    try {
      const response = await handleApiCall(`api/get_attendees/?event=${event}`);
      setAttendees(response.data);
      return response;
    } catch (err) {
      console.log(err);
    }
  };

  // get attendees csv
  const getAttendeesCSV = async (event) => {
    try {
      const response = await handleApiCall(`api/get_attendees_csv/${event}`);
      setCSVFileName(`${event}.csv`);
      setDataCSV(response);
      return response;
    } catch (err) {
      console.log(err);
    }
  };

  // get latest event
  const getLatestEvent = async () => {
    try {
      const response = await handleApiCall("api/get_latest_event", "GET");
      setLatestEvent(response.data);
      localStorage.setItem("lastest_event", JSON.stringify(response.data));
      return response;
    } catch (err) {
      console.log(err);
    }
  };

  // get all events
  const getEvents = async () => {
    try {
      const response = await handleApiCall("api/events", "GET");
      setEvents(response.data);
      return response;
    } catch (err) {
      console.log(err);
    }
  };

  // add new event
  const addEvent = async (payload) => {
    try {
      const response = await handleApiCallFormData(
        "api/events/",
        "POST",
        payload
      );
      setEvents([...events, response.data]);
      toast.success("Successfully Added New Event");
      return response;
    } catch (err) {
      console.log(err);
    }
  };

  // upate event
  const updateEvent = async (payload, id) => {
    try {
      const response = await handleApiCallFormData(
        `api/events/${id}/`,
        "PATCH",
        payload
      );
      setEvents(
        events.map((event) => (event.id === id ? { ...response.data } : event))
      );
      toast.success("Event Updated");
      return response;
    } catch (err) {
      console.log(err);
    }
  };

  // delete event
  const deleteEvent = async (id) => {
    try {
      const response = await handleApiCall(`api/events/${id}`, "DELETE");
      setEvents(events.filter((event) => event.id !== id));
      toast.success("Event has been Deleted");

      return response;
    } catch (err) {
      console.log(err);
    }
  };

  return {
    addAttendee,
    getLatestEvent,
    getEvents,
    latestEvent,
    addEvent,
    events,
    getAttendees,
    getAttendeesCSV,
    setEvents,
    updateEvent,
    deleteEvent,
    attendees,
    dataCSV,
    CSVFileName,
    setLatestEvent,
  };
};

export default useEventState;
